var _style, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "23 23 90 90",
    style: {
      enableBackground: "new 0 0 113.73 113.73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DCDBDB;}\n\t.st1{fill:#140F41;}\n\t.st2{fill:#A5A5A5;}\n\t.st3{fill:#453192;}\n\t.st4{fill:#CD1F38;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.87,68.7L73.87,68.7c-4.37,0-7.95-3.58-7.95-7.95V49.62c0-4.37,3.58-7.95,7.95-7.95h0 c4.37,0,7.95,3.58,7.95,7.95v11.13C81.82,65.12,78.24,68.7,73.87,68.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.02,49.82c-4.49,0-8.15-3.66-8.15-8.15s3.66-8.15,8.15-8.15s8.15,3.66,8.15,8.15S78.52,49.82,74.02,49.82z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 74.02,
    cy: 40.98,
    r: 6.51
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "71.81,34.47 71.81,37.72 74.02,39.44 74.02,33.95  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "76.23,34.47 76.23,37.72 74.02,39.44 74.02,33.95  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "70.63,66.64 67.93,63.27 67.95,50.07 68.88,47.34 69.83,47.66 68.93,50.31 68.93,62.92 71.41,66.02 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "77.19,66.64 76.41,66.02 78.89,62.92 78.89,50.31 77.99,47.66 78.94,47.34 79.89,50.23 79.89,63.27 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "71.55,67.25 70.49,67.25 69.95,66.33 70.49,65.41 71.55,65.41 72.08,66.33  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "77.33,67.25 76.27,67.25 75.73,66.33 76.27,65.41 77.33,65.41 77.86,66.33  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 69.22,
    y: 41.42,
    className: "st1",
    width: 3.41,
    height: 1.41
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 75.35,
    y: 41.42,
    className: "st1",
    width: 3.41,
    height: 1.41
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.2,56.94L56.2,56.94c-4.27,0-7.75-3.49-7.75-7.75V38.33c0-4.27,3.49-7.75,7.75-7.75h0 c4.27,0,7.75,3.49,7.75,7.75v10.86C63.96,53.45,60.47,56.94,56.2,56.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.36,38.53c-4.38,0-7.95-3.57-7.95-7.95s3.57-7.95,7.95-7.95s7.95,3.57,7.95,7.95S60.74,38.53,56.36,38.53z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 56.36,
    cy: 29.9,
    r: 6.35
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "54.2,23.55 54.2,26.73 56.36,28.4 56.36,23.04  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "58.51,23.55 58.51,26.73 56.36,28.4 56.36,23.04  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "53.04,54.95 50.4,51.65 50.43,38.77 51.33,36.1 52.28,36.42 51.4,39.01 51.4,51.3 53.82,54.32  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "59.46,54.95 58.68,54.32 61.09,51.3 61.09,39.01 60.22,36.42 61.16,36.1 62.09,38.93 62.09,51.65 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "53.95,55.54 52.9,55.54 52.37,54.63 52.9,53.72 53.95,53.72 54.48,54.63  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "59.59,55.54 58.54,55.54 58.01,54.63 58.54,53.72 59.59,53.72 60.12,54.63  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51.66,
    y: 30.32,
    className: "st1",
    width: 3.35,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 57.64,
    y: 30.32,
    className: "st1",
    width: 3.35,
    height: 1.4
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M38.56,68.53L38.56,68.53c-4.37,0-7.95-3.58-7.95-7.95V49.45c0-4.37,3.58-7.95,7.95-7.95h0 c4.37,0,7.95,3.58,7.95,7.95v11.13C46.51,64.95,42.93,68.53,38.56,68.53z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.72,49.65c-4.49,0-8.15-3.66-8.15-8.15s3.66-8.15,8.15-8.15s8.15,3.66,8.15,8.15S43.21,49.65,38.72,49.65z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 38.72,
    cy: 40.81,
    r: 6.51
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "36.51,34.3 36.51,37.56 38.72,39.27 38.72,33.78  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "40.93,34.3 40.93,37.56 38.72,39.27 38.72,33.78  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "35.32,66.47 32.62,63.1 32.65,49.9 33.57,47.17 34.52,47.49 33.62,50.14 33.62,62.75 36.1,65.85 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "41.88,66.47 41.1,65.85 43.58,62.75 43.58,50.14 42.69,47.49 43.63,47.17 44.58,50.06 44.58,63.1 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "36.24,67.08 35.18,67.08 34.65,66.16 35.18,65.24 36.24,65.24 36.78,66.16  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "42.03,67.08 40.96,67.08 40.43,66.16 40.96,65.24 42.03,65.24 42.56,66.16  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 33.92,
    y: 41.25,
    className: "st1",
    width: 3.41,
    height: 1.41
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 40.05,
    y: 41.25,
    className: "st1",
    width: 3.41,
    height: 1.41
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.17,80.96c-6.19,0-11.22-4.8-11.22-10.7V56.67c0-5.9,5.04-10.71,11.22-10.71s11.22,4.8,11.22,10.71v13.59 C67.39,76.16,62.36,80.96,56.17,80.96z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M56.17,79.96L56.17,79.96c-5.34,0-9.7-4.37-9.7-9.7V56.67c0-5.34,4.37-9.7,9.7-9.7h0c5.34,0,9.7,4.37,9.7,9.7 v13.59C65.87,75.6,61.5,79.96,56.17,79.96z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.36,56.92c-5.49,0-9.95-4.46-9.95-9.95s4.46-9.95,9.95-9.95s9.95,4.46,9.95,9.95S61.84,56.92,56.36,56.92z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 56.36,
    cy: 46.12,
    r: 7.95
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "53.66,38.17 53.66,42.15 56.36,44.24 56.36,37.54  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "59.05,38.17 59.05,42.15 56.36,44.24 56.36,37.54  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "52.3,77.39 49.03,73.29 49.05,57.26 50.18,53.92 51.13,54.24 50.03,57.5 50.03,72.94 53.08,76.76 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "60.14,77.39 59.36,76.76 62.41,72.94 62.41,57.5 61.31,54.24 62.25,53.92 63.41,57.42 63.41,73.29 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.28,78.09H52.1l-0.59-1.01l0.59-1.02h1.17l0.59,1.02L53.28,78.09z M52.68,77.09l0.03-0.01l-0.03-0.02 l-0.01,0.02L52.68,77.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.33,78.09h-1.17l-0.59-1.01l0.59-1.02h1.17l0.58,1.02L60.33,78.09z M59.74,77.09l0.03-0.01l-0.03-0.02 l-0.01,0.02L59.74,77.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 50.61,
    y: 46.77,
    className: "st1",
    width: 3.94,
    height: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 58.09,
    y: 46.77,
    className: "st1",
    width: 3.94,
    height: 1.5
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.87,88.44c0,0.65-0.28,0.95-0.93,0.97l0.88,0.77c0.08,0.07,0.04,0.18-0.05,0.18h-1.1 c-0.13,0-0.2-0.03-0.28-0.11l-0.88-0.84h-1.26c-0.71,0-1.02-0.29-1.02-0.97v-2.31c0-0.68,0.32-0.97,1.02-0.97h2.6 c0.71,0,1.02,0.29,1.02,0.97V88.44z M48.64,86.52c0-0.33-0.07-0.39-0.47-0.39h-1.24c-0.4,0-0.47,0.06-0.47,0.39v1.52 c0,0.33,0.07,0.39,0.47,0.39h1.24c0.4,0,0.47-0.06,0.47-0.39V86.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.39,88.04c0,0.33,0.07,0.39,0.47,0.39h1.08c0.4,0,0.47-0.06,0.47-0.39v-2.76c0-0.08,0.05-0.13,0.14-0.13 h0.95c0.08,0,0.14,0.05,0.14,0.13v3.15c0,0.68-0.3,0.97-1.02,0.97h-2.44c-0.71,0-1.02-0.29-1.02-0.97v-3.15 c0-0.08,0.05-0.13,0.14-0.13h0.95c0.09,0,0.14,0.05,0.14,0.13V88.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.12,88.69h-2.05l-0.23,0.6c-0.03,0.08-0.09,0.13-0.19,0.13h-1c-0.08,0-0.12-0.06-0.08-0.14l1.67-3.99 c0.03-0.08,0.09-0.13,0.2-0.13h1.39c0.1,0,0.16,0.04,0.19,0.13l1.67,3.99c0.03,0.08-0.01,0.14-0.08,0.14h-1.06 c-0.11,0-0.17-0.04-0.2-0.13L60.12,88.69z M58.44,87.73h1.3l-0.65-1.68L58.44,87.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.87,85.15c0.85,0,1.34,0.47,1.34,1.28v1.69c0,0.82-0.5,1.28-1.34,1.28h-3.02c-0.09,0-0.14-0.05-0.14-0.13 v-3.99c0-0.08,0.05-0.13,0.14-0.13H65.87z M63.94,88.43h1.49c0.41,0,0.56-0.12,0.56-0.47V86.6c0-0.34-0.15-0.47-0.56-0.47h-1.49 V88.43z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuad);
export default __webpack_public_path__ + "static/media/quad.56f6ae5685b26b9f7371b0794ffdebc6.svg";
export { ForwardRef as ReactComponent };